import { useEffect } from "react";

const classes = {};

const useBodyClass = (className) => {
    useEffect(() => {
        classes[className] = classes[className] ? classes[className] + 1 : 1;
        if(classes[className] === 1) {
            document.body.classList.add(className);
        }

        return () => {
            classes[className] = classes[className] - 1;
            if(classes[className] === 0) {
                document.body.classList.remove(className);
            }
        }
    }, [className])
};

export default useBodyClass;
